import {Loader} from '@mantine/core';
import Image from 'next/image';
import {useEffect, useState} from 'react';
import {GoogleAdBannerName} from '../../../config/constants/googleAdBanner';
import {SPECIAL_POST_SLUGS} from '../../../core/entities/columns/constants';
import {isInnerUser} from '../../../core/usecases/isInnerUser';
import {useAuth} from '../../../core/usecases/useAuth';
import {GoogleAdBanner} from '../../../shared/components/Banner/GoogleAdBanner';
import {CommonLink} from '../../../shared/components/CommonLink';
import {useGoogleAdBanner} from '../../../shared/services/useGoogleAdBanner';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';
import {addStyleToPostContent} from '../usecases/addStyleToPostContent';
import {RegistrationNavigationBottom} from './Container/Presenter/RegistrationNavigationBottom';
import {RegistrationNavigationTop} from './Container/Presenter/RegistrationNavigationTop';
import {ShareButtonsForPostContent} from './Container/Presenter/ShareButtonsForPostContent';
import {WpEditLink} from './Container/Presenter/WpEditLink';
import {SpecialIndex} from './Container/SpecialIndex';

type Props = {
  slug: string;
  columnId: string;
  parsedContent: string;
  isWpContent: boolean;
  title: string;
  currentUrl: string;
};

export const SpecialPostContent: React.FC<Props> = ({
  slug,
  columnId,
  parsedContent,
  isWpContent,
  title,
  currentUrl,
}: Props) => {
  const googleAdBannerNames = [
    GoogleAdBannerName.C_OVER_POST,
    GoogleAdBannerName.C_UNDER_POST,
  ];
  const {setShouldRefetch} = useGoogleAdBanner(googleAdBannerNames);
  const {isSignedIn, user} = useAuth();
  const canEditWp = user?.email ? isInnerUser(user?.email) : false;
  const {isPC} = useMediaQuery();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    addStyleToPostContent()
      .then((): void => {
        setIsLoading(false);
      })
      .catch((): void => {
        throw new Error('Failed to add style to DOM');
      });
    setShouldRefetch(true);
  }, []);

  return (
    <div className="w-full pc:w-[664px] pc:ml-12">
      <ShareButtonsForPostContent title={title} currentUrl={currentUrl} />
      {!isSignedIn && <RegistrationNavigationTop />}
      {isWpContent && canEditWp && <WpEditLink columnId={columnId} />}
      {isPC && (
        <div className="bg-white py-16 flex justify-center h-[92px]">
          <GoogleAdBanner googleAdBannerName={GoogleAdBannerName.C_OVER_POST} />
        </div>
      )}
      <div className="bg-white p-16">
        {isLoading && (
          <div className="w-full h-[150px] flex justify-center items-center">
            <Loader color="gray" />
          </div>
        )}
        <div
          id="postContent"
          className={`${isLoading ? 'hidden' : ''} text-base text-black-1 leading`}
          dangerouslySetInnerHTML={{
            __html: parsedContent,
          }}
        />

        {slug === SPECIAL_POST_SLUGS.INDEX && <SpecialIndex />}

        {!isSignedIn && <RegistrationNavigationBottom />}
      </div>
      {isPC && (
        <div className="bg-white py-16 flex justify-center h-[92px]">
          <GoogleAdBanner
            googleAdBannerName={GoogleAdBannerName.C_UNDER_POST}
          />
        </div>
      )}
      <div className="bg-white pt-16 pb-32 flex justify-center pc:h-[108px]">
        <CommonLink href="/box/answers" className="block hover:opacity-80">
          <Image
            src="/next-image/box/banner/for_column.png"
            alt="外資就活相談室"
            width={isPC ? 468 : 337}
            height={isPC ? 60 : 43}
          />
        </CommonLink>
      </div>
    </div>
  );
};
